module.exports = __webpack_public_path__ + "img/5021659668973_.pic.7fb82421.jpg";